export default {
    GET_COMPLAINT_REMOVE_REASONS_SUCCESS: (state, data) => {
        state.complaintRemoveReasons = data
    },

    SET_COPIED_COMPLAINT: (state, data) => {
        state.copiedComplaint = data
    },

    CLEAR_COPIED_COMPLAINT: (state) => {
        state.copiedComplaint = null
    },

    CLEAR_STORED_VALUES: (state) => {
        state.productionDepartments = []
        state.productionSiteGroups = []
        state.productionProcesses = []
        state.machines = []
        state.reportItems = []
        state.users = []
        state.responsibleUsers = []
        state.uploadCancelTokens = []
        state.errorCodeGroups = []
    },
}
